import { render, staticRenderFns } from "./LeaseholdNotices.vue?vue&type=template&id=777561b2&"
import script from "./LeaseholdNotices.vue?vue&type=script&lang=js&"
export * from "./LeaseholdNotices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports